import React, { useEffect } from "react";
import { SETTINGS_ROUTES } from "./settings-routes";
import { Route, Routes, useNavigate, useLocation } from "react-router-dom";
import SettingsSidebar from "./settings-sidebar";
import styles from "./styles.module.scss";
import { useSubscription } from "contexts/subscription-context";
import { useTeamContext } from "contexts/group-practice-context/TeamContext";

const Settings = () => {
  const { canAccessFeature } = useSubscription();
  const { canAccessFeatureByRole } = useTeamContext();

  const navigate = useNavigate();
  const { pathname } = useLocation();
  useEffect(() => {
    if (
      !canAccessFeatureByRole("profileTab") &&
      pathname.includes("/pro-dashboard/settings/my-profile")
    ) {
      navigate("/pro-dashboard/settings/client-portal");
    }
  }, [canAccessFeatureByRole, navigate, pathname]);

  const availableSettings = SETTINGS_ROUTES.filter(
    (route) =>
      canAccessFeatureByRole(route.roleFeatureName ?? "") &&
      (!route.featureName || canAccessFeature(route.featureName)),
  );

  const getRoutes = () =>
    availableSettings.map((prop, key) => {
      return <Route path={prop.path} element={<prop.component />} key={key} />;
    });

  return (
    <>
      <SettingsSidebar routes={availableSettings} />
      <div className={styles["settings__content"]}>
        <Routes>{getRoutes()}</Routes>
      </div>
    </>
  );
};

export default Settings;
